module.exports = __webpack_public_path__ + "static/media/lion-modal.3e3d42e8.gif";